import { render, staticRenderFns } from "./Myheader.vue?vue&type=template&id=b85c1cd4&scoped=true&"
import script from "./Myheader.vue?vue&type=script&lang=js&"
export * from "./Myheader.vue?vue&type=script&lang=js&"
import style0 from "./Myheader.vue?vue&type=style&index=0&id=b85c1cd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85c1cd4",
  null
  
)

export default component.exports